import React, { useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom';

import Popup from '@/components/Popup/index.jsx';
import {GET_MY_WISHES} from '@/services/wish';
import imgBg from '@/assets/images/noWish/bg.png';
import imgNone from '@/assets/images/noWish/none.png';
import ShowWishDetail from '@/pages/components/dialog/wishDetail';

import styles from './index.less';

const MyWish=(props)=>{
  const {destory} = props;
  const [list,setList] = useState(null)
  const init= async ()=>{
    const req = await GET_MY_WISHES();
    if(req?.code==0){
      setList(req?.data||[]);
    }
  }
  useEffect(()=>{
    init();
  },[])
  const onClose=()=>{
    destory(false);
  }
  const onDetail= (item)=>{
    ShowWishDetail(item);
    // sessionStorage.setItem('wish',JSON.stringify(item));
    // location.href=`/#/wishDetail/${item.id}`;
    destory(false);

  }

  const hasList=()=>{
    return list?.length>0;
  }
  if(!list)return <></>

  return (
    <section className={styles.center}>
      <section className={`${styles.wrap}`} >
        <img className={styles.bg} src={imgBg} />
        {
          hasList()&&
          <section className={styles.wishList} data-center={list.length<=3}>
          {
            list?.map((item,idx)=>{
              const {wish} = item;
              return (
                <hgroup className={styles.wish} key={idx} onClick={onDetail.bind(this,item)}>
                  <div className={styles.labelGroup}>
                    <span>{wish.name||'-'}的心愿</span>
                    <span>{wish.content||'-'}</span>
                  </div>
                  {
                    wish.state=='Completed'?
                    <div className={styles.btn} disabled>已寄出</div>
                    :<div className={styles.btn}>待寄出</div>
                  }
                  <div className={styles.arrow}></div>
                </hgroup>
              )
            })
          }
          </section>
        }
        {
          !hasList()&&(
            <section className={styles.wishList}>
              <img className={styles.none} src={imgNone} />
              <span className={styles.text}>还没有领取心愿哦！</span>
            </section>
          )
        }
        
        <div onClick={onClose} className={styles.close}></div>
      </section>
    </section>
  )
}

const ShowMyWish=(props)=>{
  return new Promise(resolve=>{
    let popup = Popup(resolve);
    ReactDOM.render(
      <MyWish  destory={popup.destory} list={props?.list||[]} />,
      popup.dom
    );
  })
}

export default ShowMyWish;